import CollapsibleGroup from "../../../views/cloud/CreateCloudView/CreateCloudComponents/CollapsibleGroup";

interface Props {
  setPage: (newPage: "Selector" | "Share_Record" | "Share_Record_Page") => void;
  notGlobalApp: boolean;
}

function SharedRecordSelectionType({ setPage, notGlobalApp }: Props) {
  return (
    <>
      <CollapsibleGroup
        icon="mdi mdi-sync"
        title={`Share Record`}
        description={`Allow this record to be COPIED or SYNCED with other users and organizations`}
        collapsible={false}
        onClick={() => setPage("Share_Record")}
        disabled={notGlobalApp}
        disabledMessage="You can't share records that aren't in a Global App"
      />
      <CollapsibleGroup
        icon="mdi mdi-file-document-arrow-right-outline"
        title={`Shared Record Page`}
        description={`Get a link to this page so it can be seen by Anonymous, Password, or GrowthCloud users.`}
        collapsible={false}
        onClick={() => setPage("Share_Record_Page")}
      />
    </>
  );
}

export default SharedRecordSelectionType;
